export default __webpack_public_path__ + "static/media/tick.c4e9bc54.jpg";